import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import type { AboutYourselfConfirmDialogsProps } from "../../../types/tabs";

export function AboutYourselfConfirmDialogs({
  pendingVerifyEmail,
  pendingSendLink,
  onVerify,
  onCancelVerify,
  onSendApplicationLink,
  onCancelSendApplicationLink,
  testIdPrefix,
}: AboutYourselfConfirmDialogsProps) {
  return (
    <>
      <ConfirmDialog
        isOpen={pendingVerifyEmail !== null}
        title="Verify Email"
        message={`Do you want to Verify email ${pendingVerifyEmail ?? ""} ?`}
        primaryLabel="Yes"
        secondaryLabel="No"
        onPrimary={onVerify}
        onSecondary={onCancelVerify}
        overlayDataTestId={`${testIdPrefix}-verify-email`}
        primaryButtonDataTestId={`${testIdPrefix}-verify-email-primary-button`}
        secondaryButtonDataTestId={`${testIdPrefix}-verify-email-secondary-button`}
        closeButtonDataTestId={`${testIdPrefix}-verify-email-close-button`}
      />
      <ConfirmDialog
        isOpen={pendingSendLink !== null}
        title="Send Applicant Link"
        message={`Send Applicant Link ${pendingSendLink === "email" ? "Email" : "SMS"} to Resident`}
        primaryLabel="Yes"
        secondaryLabel="No"
        onPrimary={onSendApplicationLink}
        onSecondary={onCancelSendApplicationLink}
        overlayDataTestId={`${testIdPrefix}-send-applicant-link`}
        primaryButtonDataTestId={`${testIdPrefix}-send-applicant-link-primary-button`}
        secondaryButtonDataTestId={`${testIdPrefix}-send-applicant-link-secondary-button`}
        closeButtonDataTestId={`${testIdPrefix}-send-applicant-link-close-button`}
      />
    </>
  );
}
